var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.089,
    height: 89.026,
    viewBox: "0 0 79.089 89.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442",
    transform: "translate(7694 16524.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9112",
    "data-name": "Path 9112",
    d: "M0,460.988l15.9,15.886,7.6-7.7L7.848,453.058Z",
    transform: "translate(-7694 -16912.848)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9113",
    "data-name": "Path 9113",
    d: "M77.037,366.277l11.643,11.984,3.593-3.391s.7-.767,4.123-1.279,25.49-3.9,26.835-4.478,20.242-11.354,20.242-11.354,4.024-3.687-.831-7c-.96-.656-2.6-.554-4.478.49s-15.88,7.842-15.88,7.842l-5.054-.112a4.816,4.816,0,0,1-3.609,2.591c-2.431.171-13.093.064-13.093.064s-1.546-1.023.325-1.535l13.13-.085s4.592-1.858,1-6.013c-1.088-1.258-16.434-2.794-20.689-2.538S84.013,355.3,81.166,360a63.108,63.108,0,0,1-4.136,6.279",
    transform: "translate(-7759.949 -16824.916)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9114",
    "data-name": "Path 9114",
    d: "M147.111,335.863v-4.648l49.6-.085v3.177L182.1,341.183H177.88s.122-4.906-3.359-5.629c-3.707-.771-5.566-.608-17.255-1.983-3.576-.421-8.528,1.77-10.156,2.292",
    transform: "translate(-7819.937 -16808.469)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    width: 49.597,
    height: 4.776,
    transform: "translate(-7672.826 -16486.275)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9115",
    "data-name": "Path 9115",
    d: "M366,42.2l2.051,8.853a5.372,5.372,0,0,0-2.975,4.686L353.9,57.983c.9-3.245.547-7.088-1.044-11.179a29.752,29.752,0,0,0-2.581-5.1L361.3,39.147a5.306,5.306,0,0,0,4.7,3.046",
    transform: "translate(-7993.859 -16558.514)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9116",
    "data-name": "Path 9116",
    d: "M144.321,22.25c-1.593-4.091-1.947-7.935-1.045-11.179L132.1,13.32a5.367,5.367,0,0,1-2.975,4.686l2.052,8.855a5.3,5.3,0,0,1,4.7,3.046L146.9,27.354a29.868,29.868,0,0,1-2.581-5.1m0,0c-1.593-4.091-1.947-7.935-1.045-11.179L132.1,13.32a5.367,5.367,0,0,1-2.975,4.686l2.052,8.855a5.3,5.3,0,0,1,4.7,3.046L146.9,27.354a29.868,29.868,0,0,1-2.581-5.1m34.838.481L174.548,1.986A2.545,2.545,0,0,0,171.521.06l-46.44,10.321a2.542,2.542,0,0,0-1.926,3.025l4.609,20.745a2.545,2.545,0,0,0,3.027,1.926l46.444-10.321a2.543,2.543,0,0,0,1.926-3.025m-43.912,8.355-.151-.422a4.311,4.311,0,0,0-4.289-2.8l-.427.027-.094-.417-2.343-10.1.425-.15c2.858-1.009,2.742-4.163,2.735-4.3l-.021-.433.424-.086L144.79,9.74l-.3.838c-2.759,7.724,3.581,16.72,3.644,16.81l.439.613ZM153.6,23.241l.069.368a1.239,1.239,0,0,1-2.437.455l-.038-.209a4.653,4.653,0,0,1-2.135-.436,1.24,1.24,0,1,1,.916-2.3l.037.016a2.436,2.436,0,0,0,.993.25,4.814,4.814,0,0,0,.895-.119,1.406,1.406,0,0,0,1.15-1.416A1,1,0,0,0,152.1,18.8a11.092,11.092,0,0,1-3.271-.887,2.982,2.982,0,0,1-1.52-2.7,3.31,3.31,0,0,1,1.727-2.947l-.048-.25a1.24,1.24,0,0,1,2.437-.455l.04.213a4.123,4.123,0,0,1,1.394.384,1.24,1.24,0,0,1-1.1,2.225,1.7,1.7,0,0,0-1.557.067.856.856,0,0,0-.419.768.586.586,0,0,0,.187.5,9.355,9.355,0,0,0,2.509.636,3.486,3.486,0,0,1,3.051,3.446,3.943,3.943,0,0,1-1.929,3.439m20.724-4.923c-2.858,1.009-2.742,4.164-2.736,4.3l.022.432-.425.088L157.9,25.806l.3-.843c2.755-7.712-3.581-16.715-3.645-16.809l-.439-.613,13.324-3.086.153.422a4.365,4.365,0,0,0,4.288,2.8l.429-.03,2.437,10.517Zm-31.051-7.244L132.1,13.323a5.367,5.367,0,0,1-2.975,4.686l2.052,8.855a5.3,5.3,0,0,1,4.7,3.046L146.9,27.354a29.868,29.868,0,0,1-2.581-5.1c-1.593-4.091-1.947-7.935-1.045-11.179",
    transform: "translate(-7799.376 -16525)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetoIcon);
export default __webpack_public_path__ + "static/media/NetoIcon.392fd0d7fa41419f9c94f1d62c54e982.svg";
export { ForwardRef as ReactComponent };